<template>
  <div style="" :class="{ 'mb-[2lh]': small }">
    <TicketComponent
      :rightCols="5"
      borderSize="15px"
      :middleSizePercent="2"
      :vertBorderSizePerccent="6"
      leftBorderShape="none"
      rightBorderShape="none"
    >
      <template #bg>
        <div
          class="absolute top-0 left-0 w-full h-full rounded-2xl"
          :style="{ backgroundColor: color }"
        ></div>
        <div
          class="absolute left-0 top-0 w-full h-full rounded-2xl"
          style="
            background: linear-gradient(70deg, #fff3 0%, #fff9 60%, #fff4 100%);
          "
        ></div>
      </template>
      <template #left>
        <div class="p-2 h-full">
          <div class="grid grid-cols-2  h-full text-center">
            <div
              class="h-full flex items-center justify-center right-2 overflow-hidden"
            >
              <div class="w-[6rem] min-w-[6rem] h-full ">
                <ColorImg
                  src="/images/logo.png"
                  class="rotate-90 object-contain w-full h-full bg-white "
                  alt=""
                />
              </div>
            </div>
            <div
              class="text-sm  [writing-mode:vertical-rl] [text-orientation:mixed] text-white h-full"
            >
              <div
                class="px-2"
                :class="{
                  'py-2': small,
                  'py-2': !small
                }"
              >
                <!-- {{ description }} -->
                On s'fait un rapidoo ?
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="relative h-full">
        <div class="grid grid-cols-6 h-full">
          <div class="col-span-5 p-5 flex flex-col">
            <div
              class="font-island-moments text-center truncate text-white"
              :class="{
                'text-3xl': small,
                'text-5xl': !small
              }"
            >
              {{ title }}
            </div>
            <div
              class="text-white h-[2lh]"
              :class="{
                'overflow-hidden': small
              }"
            >
              {{ description }}
            </div>
            <div class="py-1"></div>
            <div class="mt-auto flex items-center justify-between text-white">
              <div class="text-4xl">-{{ discount }}{{ discountUnit }}</div>
              <div>
                <button
                  class="buttonComponent bg-black px-6 py-3"
                  @click="$emit('useRequested')"
                >
                  {{ buttonText || 'Utiliser' }}
                </button>
              </div>
            </div>
          </div>
          <div class="relative">
            <div class="absolute w-full h-full flex justify-center">
              <ImgComponent
                src="/images/coupons/reductionBadge.png"
                alt=""
                class="h-full !max-w-[10000px]"
              />
            </div>
          </div>
        </div>
      </div>
    </TicketComponent>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'red'
    },
    code: {
      type: String,
      default: ''
    },
    discount: {
      type: [String, Number],
      default: ''
    },
    discountUnit: {
      type: String,
      default: '%'
    },
    small: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: '/images/coupons/giftWhite.png'
    }
  },
  data() {
    return {};
  },
  beforeUnmount() {},
  mounted() {},
  methods: {}
};
</script>
